module.exports = __webpack_public_path__ + "img/moto-coverage.a9f5cea9.svg";